<template>
  <div
    v-infinite-scroll="loadMore"
    infinite-scroll-disabled="scrollDisabled"
    infinite-scroll-immediate-check="false">
      <div class="sh-row-main">
        <div class="row-list-item" v-for="(item, index) in dataList" :key="item.BrandID">
          <div class="list-img" @click="entoDetailPage(item.ProductID)">
            <img v-lazy="item.ShowPicUrl" alt="" :key="item.ProductID">
            <div class="soldout-mask" v-if="!item.StockCount">
              <p>Sorry</p>
              <p>抢光啦</p>
            </div>
          </div>
          <div class="list-cnt">
            <div class="list-cnt-title" @click="entoDetailPage(item.ProductID)">
              <div class="title">
                <!-- <span class="platform-tag tm" v-if="item.ShopType.toLocaleUpperCase() === 'B'">天猫</span>
                <span class="platform-tag pdd" v-if="item.ShopType.toLocaleUpperCase() === 'P'">拼多多</span>
                <span class="platform-tag jd" v-if="item.ShopType.toLocaleUpperCase() === 'J'">京东</span> -->
                <plat-formLogo :shopType="item.ShopType.toLocaleUpperCase()"></plat-formLogo>
                <template>{{item.TitleShort || '----'}}</template>
              </div>
              <div class="item-price">
                <div class='l-prod-price'>
                  <div class='price'>
                    <div class='yuan'>￥</div>
                    <div class='money'>0</div>
                  </div>
                  <div class='through'><span>￥</span>{{item.ProductPrice}}</div>
                </div>
              </div>
            </div>
            <div class="list-cnt-btm">
              <div class="list-btm-price">
                <div class="l-freecard-tag" v-if="item.FreeCardNum !== null">
                  <span>免单卡</span>
                  <span>{{isNewcomer ? 1 : item.FreeCardNum}}</span>
                </div>
                <div class="l-rebate-tag">
                  <span class="t">返利</span>
                  <span class="rmb">￥{{item.ProductPrice}}</span>
                </div>
              </div>
              <div
                v-if="item.IsStockNoZero"
                class="list-btm-btn"
                @click="entoDetailPage(item.ProductID)">马上抢<i class="iconfont icon-xiangzuo1"></i>
              </div>
              <div
                v-else
                class="list-btm-btn"
                @click="remindClick(item.ProductID, item.IsFavorite, index)">
                {{item.IsFavorite ? '取消收藏' : '收藏'}}
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { mapGetters, mapMutations } from 'vuex'
import {
  ProductFavoriteAdd,
  IsSetRemind
} from '@/api/remind'

export default {
  name: 'FlashSaleList',
  data () {
    return {
      isSetting: false
    }
  },
  props: {
    dataList: {
      type: Array,
      require: true,
      default: function () {
        return []
      }
    },
    // 是否是新人
    isNewcomer: {
      type: Boolean,
      default: false
    },
    scrollDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'loginState',
      'getIsApp',
      'getIsAuthorized'
    ])
  },
  methods: {
    ...mapMutations([
      'AUTHORIZE_POPUP_SHOW'
    ]),
    loadMore () {
      this.$emit('loadMore')
    },
    entoDetailPage (productID) {
      this.$router.push({
        name: 'goodsDetail',
        query: {
          productID: productID,
          isFreeCard: true
        }
      })
    },
    // 添加收藏夹/移出收藏夹
    remindClick (productID, isBuyRemind, index) {
      if (!this.loginState) {
        this.unLoginModal()
        return
      }
      if (this.isSetting) return
      this.isSetting = true
      if (isBuyRemind) {
        // 已设置，点击移出
        Indicator.open({
          text: '移出中',
          spinnerType: 'triple-bounce'
        })
        IsSetRemind({ productId: productID }).then(res => {
          Indicator.close()
          this.isSetting = false
          this.$set(this.dataList[index], 'IsFavorite', false)
          Toast('已移出收藏夹')
        }).catch(err => {
          Indicator.close()
          this.isSetting = false
          Toast(err.ErrMsg)
        })
      } else {
        // 加入收藏夹
        Indicator.open({
          text: '加入收藏中',
          spinnerType: 'triple-bounce'
        })
        ProductFavoriteAdd({ productId: productID }).then(res => {
          Indicator.close()
          this.isSetting = false
          this.$set(this.dataList[index], 'IsFavorite', true)
          Toast('已加入收藏夹')
        }).catch(err => {
          Indicator.close()
          this.isSetting = false
          Toast(err.ErrMsg)
        })
      }
    },
    unLoginModal () {
      if (!this.getIsAuthorized && this.getIsApp) {
        // 弹出授权登录弹窗
        this.AUTHORIZE_POPUP_SHOW(true)
        return
      }
      if (this.getIsAuthorized && this.getIsApp) {
        this.$store.commit('LOGINDIALOG_SHOW', true)
        return
      }
      this.$store.commit('LOGINDIALOG_SHOW', true)
    }
  }
}
</script>

<style scoped>
  .sh-row-main{
    /* padding-top: 3%; */
    /* margin-top: 3px; */
    background: linear-gradient(to bottom, #fff 0, #f1f1f1 300px, #f1f1f1);
  }
  .row-list-item{
    position: relative;
    display: flex;
    align-items: center;
    height: 125px;
    width: 97%;
    box-sizing: border-box;
    padding: 8px 10px;
    background: #fff;
    margin: 10px auto 0 auto;
    border-radius: 10px;
  }
  .row-list-item:first-child{
    margin-top: 0;
  }
  .row-list-item .list-img{
    position: relative;
    width: 109px;
    height: 100%;
    flex-shrink: 0;
  }
  .list-img img{
    display: block;
    height: 100%;
    width: 100%;
    border-radius: 3px;
  }
  .row-list-item .list-cnt{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: column;
    margin-left: 10px;
    flex-grow: 1;
    height: 100%;
    box-sizing: border-box;
  }
  .list-cnt-title{
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .list-cnt-title .title{
    max-height: 40px;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .item-price{
    margin-top: 5px;
    text-align: left;
    box-sizing: border-box;
  }
  .list-cnt-btm{
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
  }
  .list-btm-price{
    display: flex;
    align-items: center;
  }
  .list-btm-btn{
    height: 22px;
    width: 80px;
    line-height: 22px;
    text-align: center;
    color: #000;
    border: 1px solid #000;
    padding: 2px 0;
    border-radius: 15px;
  }
  .list-btm-btn .iconfont{
    font-size: 12px;
    margin-left: 3px;
  }
</style>
